var map = {
	"./contact-perringborg.jpg": "1d76",
	"./contact.jpg": "6b2a",
	"./idea-vision.jpg": "8311",
	"./landing.jpg": "4f88",
	"./privacy-policy.jpg": "e18b",
	"./services.jpg": "bc73"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";